import React from 'react'
import { Image, Skeleton } from 'antd'
import { PosterDisplayState } from '../../../types/card'

const PREVIEW_WIDTH = 72
const PREVIEW_HEIGHT = 128

const MEDIA_DOMAIN_POSTER = process.env.REACT_APP_MEDIA_DOMAIN_POSTER!

interface PosterProps {
  image: string | undefined
  state: PosterDisplayState
}

export const Poster: React.FC<PosterProps> = React.memo(({ image, state }) => {
  const containerStyle = {
    width: PREVIEW_WIDTH,
    height: PREVIEW_HEIGHT,
    backgroundColor: '#F8F7F7',
    borderRadius: 3,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  } as const

  // Para el estado "processing"
  if (state === 'processing') {
    return (
      <div style={containerStyle}>
        <Skeleton.Image
          style={{
            width: PREVIEW_WIDTH,
            height: PREVIEW_HEIGHT,
            borderRadius: 3,
          }}
        />
        <span
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            color: '#595959',
            fontSize: 10,
            fontWeight: 600,
            background: 'rgba(255, 255, 255, 0.9)',
            padding: '4px 8px',
            borderRadius: 3,
            zIndex: 1,
          }}
        >
          En proceso
        </span>
      </div>
    )
  }

  // Para el estado "preview" con imagen disponible
  if (state === 'preview' && image) {
    const isMediaDomain = image.startsWith(MEDIA_DOMAIN_POSTER)
    const imageSrc = isMediaDomain ? `${image}?v=${Date.now()}` : image

    return (
      <div style={containerStyle}>
        <Image
          key={imageSrc}
          src={imageSrc}
          alt='preview'
          width='100%'
          height='100%'
          style={{ objectFit: 'cover', borderRadius: 3 }}
          preview={true}
        />
      </div>
    )
  }

  // Para el estado "empty" (y cualquier otro caso)
  return <div style={containerStyle} />
})
